export enum TaskResponseStatus {
    AUTO_POPULATED = 'AUTO_POPULATED',
    RESPONDED = 'RESPONDED',
    UNSYNCED = 'UNSYNCED',
    NOT_MAPPABLE = 'NOT_MAPPABLE',
}
